import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button/Button';

const PadKey = ({ padKey, onClick }) => {
  return (
    <div className="vve-pad-key-wrapper">
      <Button onClick={() => onClick(padKey.value)} className={`vve-dial-button vve-dialpad-${padKey.name}`}>
        <div className="row vve-key-icon">
          <span className="vve-dial-number">{padKey.numeric}</span>
          <span className="vve-dial-alpha">{padKey.alpha}</span>
        </div>
      </Button>
    </div>
  );
};

PadKey.propTypes = {
  padKey: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    numeric: PropTypes.any,
    alpha: PropTypes.string
  }),
  onClick: PropTypes.func
};

export default PadKey;
